export const KLINE_PUSH = 'kline/PUSH';

export const KLINE_FETCH = 'kline/KLINE_FETCH';
export const KLINE_DATA = 'kline/KLINE_DATA';

export const KLINE_UPDATE_TIME_RANGE = 'kline/KLINE_UPDATE_TIME_RANGE';
export const KLINE_UPDATE_PERIOD = 'kline/KLINE_UPDATE_PERIOD';

export const KLINE_ERROR = 'kline/KLINE_ERROR';
